const COMP_NAMES = {
  UCL: "UEFA Champions League",
  UEL: "UEFA Europa League",
  UECL: "UEFA Europa Conference League",
  EPL: "Premier League",
  CHAMP: "EFL Championship",
  LG1: "EFL League One",
  LG2: "EFL League Two",
  ENG_FA: "FA Cup",
  NAT_LEAGUE: "National League",
  NAT_NORTH: "National League North",
  NAT_SOUTH: "National League South",
  ENG_EFL: "EFL Cup",
  SCO_PREM: "Scottish Premiership",
  SCO_CHAMP: "Scottish Championship",
  SCO_1: "Scottish League One",
  SCO_2: "Scottish League Two",
  SCO_SC: "Scottish Cup",
  SCO_LC: "Scottish League Cup",
  SCO_CHAL: "Scottish Challenge Cup",
  LIGUE1: "Ligue 1",
  LIGUE2: "Ligue 2",
  FRA_NAT: "France National",
  FRA_CDF: "Coupe de France",
  BUNDES: "Bundesliga",
  BUNDES2: "2. Bundesliga",
  GER_POKAL: "DFB-Pokal",
  LA_LIGA: "La Liga",
  LA_LIGA2: "La Liga 2",
  SERIE_A: "Serie A",
  SERIE_B: "Serie B",
  ITA_COPPA: "Coppa Italia",
  POR_LIGA: "Primeira Liga",
  POR_TACA: "Taca de Portugal",
  DEN_SL: "Danish Superliga",
  NED_ERED: "Eredivisie",
  NED_EERST: "Eerste Divisie",
  NED_KNVB: "KNVB Cup",
  BEL_PRO: "Belgian Pro League",
  BEL_CUP: "Belgian Cup",
  NOR_ELI: "Eliteserien",
  NOR_CUP: "Norwegian Cup",
  SWE_ALLSV: "Allsvenskan",
  SWE_ALLS: "Allsvenskan",
  SWE_SUPER: "Superettan",
  SWE_CUP: "Swedish Cup",
  BR_SERIE_A: "Brazil Serie A",
  BR_SERIE_B: "Brazil Serie B",
  ARG_LP: "Argentina Liga Profesional",
  ARG_PN: "Primera Nacional",
  ARG_PB_METRO: "Primera B Metropolitana",
  ARG_CDL: "Copa de la Liga Profesional",
  ARG_CUP: "Copa Argentina",
  COPA_AMERICA: "Copa America",
  MEX_LIGA: "Liga MX",
  TUR_SUPER: "Turkish Super Lig",
  TUR_SUPER_LIG: "Turkish Super Lig",
  MEX_LIGA_MX: "Liga MX",
  POL_EKSTRAKLASA: "Ekstraklasa",
  POL_EKS: "Polish Ekstraklasa",
  CZE_1_LIGA: "Czech First League",
  CZE_FIRST: "Czech First League",
  SUI_SUPER_LEAGUE: "Swiss Super League",
  SUI_SUPER: "Swiss Super League",
  MLS: "Major League Soccer",
  NFL: "NFL (American Football)",
  NBA: "NBA (Basketball)",
  NHL: "NHL (Hockey)",
  NCAA: "College Football",
  CFB: "College Football",
  WC: "World Cup",
  WCQ_EUR: "World Cup Qualifiers (Europe)",
  DEFAULT: "Football",
};

const normalizeCode = (value = "") =>
  String(value || "")
    .trim()
    .toUpperCase()
    .replace(/[\s-]+/g, "_");

const prettifyFallback = (value = "") =>
  String(value || "")
    .trim()
    .replace(/_/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, (match) => match.toUpperCase());

export const prettyCompetitionName = (value, fallback = "League") => {
  const raw = String(value || "").trim();
  if (!raw) return fallback;
  const code = normalizeCode(raw);
  if (COMP_NAMES[code]) return COMP_NAMES[code];
  if (raw.includes("_") || /^[A-Z0-9_]+$/.test(raw)) {
    return prettifyFallback(code);
  }
  return prettifyFallback(raw);
};

export const formatLeagueName = (value, fallback = "League") =>
  prettyCompetitionName(value, fallback);

export { COMP_NAMES };
